import { observeElement } from '@uvocore-front/utils';
import { fetchCheckStatus, isMobile } from '../../../../utils';
import Loader from '../../../../components/UI/loader';
import './styles.scss';

const generateTemplate = data => {
  const { academicLevels, deadlines } = data;

  const MIN_DEADLINE_VALUES_LENTGH = 5;

  const template = `
    <div class="pricing-table">
      <div class="pricing-table__select styled-select">
        <select>
          ${academicLevels
            .map(
              (level, index) =>
                `<option ${index === 0 ? 'selected' : ''} value="${index}">${
                  level.short_title
                }</option>`,
            )
            .join('')}
        </select>
      </div>
      <table class="pricing-table__main">
        <thead class="pricing-table__head">
          <tr class="pricing-table__row">
            <th>
              Deadline
            </th>
            ${academicLevels.map(level => `<th>${level.short_title}</th>`).join('')}
          </tr>
        </thead>
        <tbody class="pricing-table__body">
          ${Object.values(deadlines)
            .map(deadlineItem => {
              let deadlineItemArr = Object.values(deadlineItem);

              const dealineName = deadlineItemArr[0].name;

              const emptyCellsQty = MIN_DEADLINE_VALUES_LENTGH - deadlineItemArr.length;

              deadlineItemArr = [...new Array(emptyCellsQty), ...deadlineItemArr];

              return `
                <tr class="pricing-table__row">
                  <th class="pricing-table__deadline-name">
                    <div>
                      ${dealineName}
                    </div>
                  </th>
                  ${deadlineItemArr
                    .map(
                      (level, index) =>
                        `<td class="pricing-table__price" ${
                          index === 0 ? 'data-active' : ''
                        } data-value="${index}"><div>
                          ${level ? `<span>$</span>${Math.trunc(level.pricePerPage)}` : '—'}
                          </div></td>`,
                    )
                    .join('')}
                </tr>
              `;
            })
            .join('')}
        </tbody>
      </table>
    </div>
  `;

  return template;
};

const priceTableHoveringInit = () => {
  const table = document.querySelector('.pricing-table__main');

  let activeCell;
  let activeNearbyRowCells;
  let activeNearbyColumnCells;

  const hideActiveElements = () => {
    if (activeCell) {
      activeCell.classList.remove('active-cell');
      activeCell = null;
    }

    if (activeNearbyRowCells) {
      activeNearbyRowCells.forEach(cell => cell.classList.remove('active-row-cell'));
      activeNearbyRowCells = null;
    }

    if (activeNearbyColumnCells) {
      activeNearbyColumnCells.forEach(cell => cell.classList.remove('active-column-cell'));
      activeNearbyColumnCells = null;
    }
  };

  const handleMouseOver = event => {
    if (isMobile()) return;

    const currentCell = event.target.closest('.pricing-table__price');

    hideActiveElements();

    if (!currentCell || currentCell === activeCell) return;

    activeCell = currentCell;

    const activeColumnIndex = activeCell.getAttribute('data-value');

    activeNearbyRowCells = Array.from(activeCell.parentNode.children).filter(
      cell =>
        !cell.getAttribute('data-value') || cell.getAttribute('data-value') < activeColumnIndex,
    );

    activeNearbyColumnCells = Array.from(table.querySelectorAll('.pricing-table__row'))
      .map(row => Array.from(row.children)[parseFloat(activeColumnIndex) + 1])
      .filter(cell => cell !== activeCell);

    activeNearbyRowCells.forEach(cell => cell.classList.add('active-row-cell'));
    activeNearbyColumnCells.forEach(cell => cell.classList.add('active-column-cell'));
    activeCell.classList.add('active-cell');
  };

  table.addEventListener('mouseover', handleMouseOver);
  table.addEventListener('mouseleave', hideActiveElements);
};

observeElement({
  element: '[data-pricing-table]',
  marginValue: 300,
  callback: () => {
    Loader('[data-pricing-table]');

    fetch('/assets/get_pricing_block/?siteId=113&format=json')
      .then(fetchCheckStatus)
      .then(data => {
        const tableContainer = document.querySelector('[data-pricing-table]');

        tableContainer.innerHTML = generateTemplate(data);

        const changeCurrentDeadline = index => {
          const prevActiveCells = tableContainer.querySelectorAll('[data-active]');
          const nextActiveCells = tableContainer.querySelectorAll(`[data-value="${index}"]`);

          Array.from(prevActiveCells).forEach(cell => cell.removeAttribute('data-active'));
          Array.from(nextActiveCells).forEach(cell => cell.setAttribute('data-active', ''));
        };

        tableContainer.querySelector('select').addEventListener('change', event => {
          changeCurrentDeadline(event.target.value);
        });

        priceTableHoveringInit();
      })
      .catch(error => {
        throw error;
      });
  },
});
